import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/components/SEO";
import DemoBooking from "@/pages/DemoBooking";

const SUBHEAD =
  "A 15 minute walkthrough. We will show you how a store goes live and what the numbers look like for a shop your size. No pressure to decide on the call.";

export const Route = createFileRoute("/demo")({
  head: () =>
    buildHead({
      path: "/demo",
      title: "Book a GoHub walkthrough",
      description: SUBHEAD,
      links: [
        { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
        {
          rel: "stylesheet",
          href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@400;500;600;700;800&display=swap",
        },
      ],
    }),
  component: DemoBooking,
});
